/**
 * Petri experiments are conducted into a `StringMap` of spec key -> value.
 * The value comes back in one of two shapes:
 *   - boolean specs      -> `'true'` / `'false'`
 *   - A/B experiments    -> a variant label `'A'` / `'B'`, where `'A'` is the
 *                           control (treat as OFF) and `'B'` is the variant
 *                           (treat as ON)
 *
 * `isSpecEnabled` normalizes either shape to a boolean so call sites don't have
 * to know whether a spec is wired as a plain boolean or an A/B experiment:
 *
 *   - `'true'`  / `'B'`                  -> true  (enabled)
 *   - `'false'` / `'A'` / undefined / '' -> false (disabled)
 *   - any other value                    -> false
 */
export const isSpecEnabled = (value?: string): boolean =>
  value === 'true' || value === 'B';
